/* eslint-disable */
import * as React from 'react'
import { CircularProgress } from '@mui/material'
import Pagination from "../../../../components/TablePagination"
import { SnackbarOrigin } from '@mui/material/Snackbar'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import TableSortLabel from '@mui/material/TableSortLabel'
import Paper from '@mui/material/Paper'
import Checkbox from '@mui/material/Checkbox'
import { fetchDeviceList } from '../../redux/actionCreators'
import { visuallyHidden } from '@mui/utils'
import { type RootState } from '../../../../store'
import { DeviceListState } from '../../redux/deviceListSlice'
import { type ConnectedProps, connect } from 'react-redux'
import LanguageStrings from '../../../../i18n/locales'
import { useNavigate } from 'react-router-dom'
import { changeAssetId } from '../../../device-details/redux/assetIdSlice'
import { useDispatch } from 'react-redux'
import { useAuth } from 'react-oidc-context'
import AuthError from '../../../../components/ErrorComponents/AuthError'

export interface State extends SnackbarOrigin {
    open: boolean
}
interface Data {
    name: string,
    serial_number: string,
    latitude: number,
    longitude: number,
    install_date: Date | null,
    removal_date: Date | null
}

type Order = 'asc' | 'desc'
interface HeadCell {
    disablePadding: boolean;
    id: any;
    label: string;
    numeric: boolean;
}

const TableStrings = LanguageStrings().AMIDataCollectionStrings.TableComponent
const headCells: readonly HeadCell[] = [
    {
        id: 'name',
        numeric: false,
        disablePadding: false,
        label: TableStrings.Name
    },
    {
        id: 'serial_number',
        numeric: false,
        disablePadding: false,
        label: TableStrings.SerialNumber
    },
    {
        id: 'latitude',
        numeric: false,
        disablePadding: false,
        label: TableStrings.Latitude
    },
    {
        id: 'longitude',
        numeric: false,
        disablePadding: false,
        label: TableStrings.Longitude
    },
    {
        id: 'install_date',
        numeric: false,
        disablePadding: false,
        label: TableStrings.InstallDate
    }, {
        id: 'removal_date',
        numeric: false,
        disablePadding: false,
        label: TableStrings.RemovalDate

    }
]

function EnhancedTableHead(props: any): any {
    const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, deviceList } = props
    const createSortHandler =
        (newOrderBy: keyof Data) => (event: React.MouseEvent<unknown>) => {
            onRequestSort(event, newOrderBy)
        }
        if (deviceList !== null && deviceList !== undefined) {
    return (
        <TableHead data-testid="table-header">
            <TableRow>
                <StyledTableCell padding="checkbox" style={{ display: 'none' }} >
                    <Checkbox
                        sx={{ color: "#909090" }}
                        data-testid="device-table-header-checkbox"
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onSelectAllClick}
                        inputProps={{
                            'aria-label': 'select all devices',
                        }}
                    />
                </StyledTableCell>
                {headCells.map((headCell: any) => (
                    <StyledTableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                    >
                        <TableSortLabel
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                            aria-label={headCell.label}
                            data-testid="test-sort"

                        >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <Box component="span" sx={visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </Box>
                            ) : null}
                        </TableSortLabel>
                    </StyledTableCell>
                ))}
            </TableRow>
        </TableHead>
    )}
}


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: "#F0F0F0",
        fontWeight: "700",
        fontSize: 12,
        border: "2px solid #202020",
        padding: "5px 16px",
        fontFamily: "Honeywell Sans Web"
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        color: "#d0d0d0",
        paddingLeft: "17px",
        borderBottom: "1px solid #202020",
        borderRight: 0,
        fontFamily: "Honeywell Sans Web"
    },
}))

export interface Sort {
    order: Order
    orderBy: string
}

function DeviceList(props: AllProps) {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const auth = useAuth()
    const [selected, setSelected] = React.useState<readonly string[]>([])

    React.useEffect(() => {
        if (props.searchVal === '') {
            fetchAllAssetList()
        } else if (props.searchVal !== '') {
            props.performAction()
        }
    }, [props.page, props.sort])

    React.useEffect(() => {
        if (props.searchVal !== '') {
            props.setPage(1)
            props.setSort({order:'asc', orderBy:'id'})
        }
    }, [props.searchVal])

    const fetchAllAssetList = () => {
        if (props.page >= 1) {
            props.fetchDeviceList(props.page-1, props.rowsPerPage, props.sort.order, props.sort.orderBy, auth.user?.profile.customer as string)
        }
    }


    const handleRequestSort =
        (event: React.MouseEvent<unknown>, newOrderBy: keyof Data) => {
            const isAsc = props.sort.orderBy === newOrderBy && props.sort.order === 'asc'
            const toggledOrder = isAsc ? 'desc' : 'asc'
            props.setSort({order:toggledOrder, orderBy:newOrderBy})
        }



    const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.checked && props.deviceList.deviceList ) {
            const newSelected: any = props.deviceList.deviceList.map((n: any) => n.deviceId)
            setSelected(newSelected)
            return
        }
        setSelected([])
    }

    const handleDeviceDetailClick = (assetId: string, assetName: string) => {
        dispatch(changeAssetId(assetId))
        sessionStorage.setItem('paramAssetId',  assetId != null ? assetId.toString() : '')
        sessionStorage.setItem('paramAssetName', assetName != null ? assetName.toString() : '')
        navigate(`/devicedetails`)
    }



    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        "& th": {
            border: "1px solid #202020",
        }
    }))

    const isSelected = (name: string) => selected.indexOf(name) !== -1
    if (props.deviceList.deviceList !== null && props.deviceList.deviceList !== undefined && props.deviceList.httpStatus === 200 && props.deviceList.deviceCount > 0) {
    return (
        <>
            <Box className="devices">
                <Paper sx={{ width: '100%', mb: 2, backgroundColor: "#272727", boxShadow: "unset", color: "#F0F0F0", marginBottom: "0" }}>
                    <TableContainer className='device-table'>
                        <Table
                            sx={{ minWidth: 750, color: "#f0f0f0" }}
                            aria-labelledby="tableTitle"
                            size={'small'}
                        >
                            <EnhancedTableHead
                                numSelected={selected.length}
                                order={props.sort.order}
                                orderBy={props.sort.orderBy}
                                onSelectAllClick={handleSelectAllClick}
                                onRequestSort={handleRequestSort}
                                rowCount={5}
                                deviceList={props.deviceList.deviceList}
                            />
                            <TableBody>
                                {props.deviceList.deviceList && props.deviceList.deviceList.map((row: any, index: any) => {
                                    const isItemSelected = isSelected(row.id)
                                    const labelId = `enhanced-table-checkbox-${index}`
                                    var installDate = row.install_date ? new Date(row.install_date) : null
                                    var formattedInstallDate = installDate ? installDate.toLocaleDateString('en-US') : ''
                                    var removalDate = row.removal_date ? new Date(row.removal_date) : null
                                    var formattedRemovalDate = removalDate ? removalDate.toLocaleDateString('en-US') : ''

                                    return (
                                        <StyledTableRow
                                            hover
                                            role="checkbox"
                                            aria-checked={isItemSelected}
                                            tabIndex={-1}
                                            key={row.deviceId}
                                            aria-label="devices-list-row"
                                            selected={isItemSelected}
                                            sx={{ cursor: 'pointer' }}
                                        >
                                            <StyledTableCell padding="checkbox" style={{ display: 'none' }} >
                                                <Checkbox
                                                    sx={{ color: "#909090" }}
                                                    checked={isItemSelected}
                                                    inputProps={{
                                                        'aria-labelledby': labelId,
                                                        "aria-label": "test-checkbox"
                                                    }}
                                                />
                                            </StyledTableCell>
                                            <StyledTableCell
                                            component="th"
                                            id={labelId}
                                            scope="row"
                                            padding="none"
                                            onClick={() => handleDeviceDetailClick(row.id, row.name)}
                                            aria-label='device-name'
                                            data-testid='device-name'
                                            sx={{ color: "#64C3FF !important" }} >{row.name}</StyledTableCell>
                                            <StyledTableCell
                                            >{row.serial_number}</StyledTableCell>
                                            <StyledTableCell
                                            >{row.latitude}</StyledTableCell>
                                            <StyledTableCell >{row.longitude}</StyledTableCell>
                                            <StyledTableCell >{formattedInstallDate}</StyledTableCell>
                                            <StyledTableCell >{formattedRemovalDate}</StyledTableCell>
                                        </StyledTableRow>
                                    )
                                })
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <Pagination count={props.deviceList.deviceCount} page={props.page} setPage={props.setPage} rowsPerPage={props.rowsPerPage} siblingCount={1}
                        boundaryCount={1} />
                </Paper>
            </Box>

        </>
    )}
    else if(props.deviceList.isLoading) {
        return (
        <div className='CircularprogressAmi'>
            <CircularProgress />
        </div>
        )
    }
    else if (props.deviceList.httpStatus === 401) {
        return (
                <div className='authError'><AuthError errorMessage="Unauthorized"/></div>
        )
    }
    else if (props.deviceList.httpStatus === 403) {
        return (
            <div className='authError'><AuthError errorMessage="accessForbidden"/></div>
        )
    }
    else if ((props.deviceList.deviceList !== null && props.deviceList.deviceList !== undefined && props.deviceList.deviceList.length === 0)) {
        return (
            <div className='authError'><AuthError errorMessage="NoDataPresent"/></div>
        )
    }
    else if((props.deviceList.loadingError?.includes('No assets found') || props.deviceList.loadingError?.includes("Asset not found"))){
        return (
            <div className='authError'><AuthError errorMessage="NoDataPresent"/></div>
        )
    }
    else {
        return (
            <div className='authError'><AuthError errorMessage="cannotFetch" retry={fetchAllAssetList}/></div>
        )
    }

}
interface DispatchToProps {
    fetchDeviceList: (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => void
}

const mapDispatchToProps = (dispatch: any): DispatchToProps => ({
    fetchDeviceList: (page: number, size: number, sortdir: string, sortfield: string, tenantId: string) => dispatch(fetchDeviceList(page, size, sortdir, sortfield, tenantId ))
})

interface StateToProps {
    deviceList: DeviceListState
}

const mapStateToProps = (state: RootState): StateToProps => ({
    deviceList: state.deviceList
})

const connector = connect(mapStateToProps, mapDispatchToProps)
type PropsFromRedux = ConnectedProps<typeof connector>
interface ParentProps {
    searchVal: string
    performAction: () => void
    rowsPerPage: number
    page: number
    sort: Sort
    setPage: React.Dispatch<React.SetStateAction<number>>
    setSort: React.Dispatch<React.SetStateAction<Sort>>
}
type AllProps = PropsFromRedux & ParentProps

export default connector(DeviceList)
